export enum RecordTypeEnum {
	depthFromToRecordType,
	normal
}
